import platformFeeQueries from "$/lib/queries/platform-fee-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/platform-fee")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(platformFeeQueries.simulation({}))
    return { crumb: "Avgiftssimulering" }
  },
})
